import {
  compose,
  withHandlers,
  withStateHandlers,
  withPropsOnChange,
  mapProps,
  pure,
} from 'recompose';
import debounce from 'lodash.debounce';
import * as R from 'ramda';

import { withDevice } from '~/features/App/Device';

import { DataTable as DTC } from './DataTable';

const enhance = compose(
  withStateHandlers(
    { isScrolled: false },
    {
      onScroll: () => e => {
        const isScrolled = !!R.pathOr(0, ['target', 'scrollTop'], e);

        return { isScrolled };
      },
    },
  ),
  withDevice,
  pure,
  withHandlers({
    onPageChange: ({ onChangeRouteNavigation }) => page =>
      onChangeRouteNavigation({ page }),
    onPageSizeChange: ({ onChangeRouteNavigation }) => pageSize =>
      onChangeRouteNavigation({ pageSize }),
    onSortedChange: ({ onChangeRouteNavigation }) => sort => {
      const { id, desc } = R.propOr({ desc: true }, '0', sort);

      onChangeRouteNavigation({ sortBy: desc ? '' : id });
    },
  }),
  withPropsOnChange(
    ['onPageChange', 'onPageSizeChange', 'onSortedChange'],
    ({ onPageChange, onPageSizeChange, onSortedChange }) => ({
      onPageChange: debounce(onPageChange, 500),
      onPageSizeChange: debounce(onPageSizeChange, 500),
      onSortedChange: debounce(onSortedChange, 500),
    }),
  ),
  mapProps(({ onChangeRouteNavigation, ...rest }) => ({
    ...rest,
  })),
);

export const DataTable = enhance(DTC);

DataTable.defaultProps = {
  onChangeRouteNavigation: () => {},
};
